var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcFaceFocusingFill = function SvgIcFaceFocusingFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 3.1a.9.9 0 0 0-.9.9v1A1.1 1.1 0 0 1 .9 5V4A3.1 3.1 0 0 1 4 .9h1a1.1 1.1 0 0 1 0 2.2zM4 20.9a.9.9 0 0 1-.9-.9v-1a1.1 1.1 0 0 0-2.2 0v1A3.1 3.1 0 0 0 4 23.1h1a1.1 1.1 0 0 0 0-2.2zM20.9 4a.9.9 0 0 0-.9-.9h-1a1.1 1.1 0 0 1 0-2.2h1A3.1 3.1 0 0 1 23.1 4v1a1.1 1.1 0 0 1-2.2 0zM20.9 20a.9.9 0 0 1-.9.9h-1a1.1 1.1 0 0 0 0 2.2h1a3.1 3.1 0 0 0 3.1-3.1v-1a1.1 1.1 0 0 0-2.2 0zM12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m-2.5-9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-.559 3.496c-.275 1.143-1.487 2.004-2.94 2.004-1.454 0-2.666-.86-2.942-2.004-.064-.269.165-.496.441-.496h5c.277 0 .506.227.441.496",
    clipRule: "evenodd"
  })));
};
export default SvgIcFaceFocusingFill;